export default "__VITE_ASSET__DybzGJDO__"